'use strict';

const { ItemLocation: { GLOBAL_INVENTORY, HERO_INVENTORY } } = require('../types/enums');

const isRemovingItemFromHeroInventory = ({ from, to, to_game_item }) =>  (
  from.location === HERO_INVENTORY && to.location === GLOBAL_INVENTORY)
|| (from.location === GLOBAL_INVENTORY && to.location === HERO_INVENTORY && to_game_item
);
module.exports = isRemovingItemFromHeroInventory;
